import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './styles.scss';
import { Select, TreeSelect } from 'antd';
import { getRecommends } from '../../../actions/recommend';
import { getTags } from '../../../actions/recommend-tag';
import { getDimensionTags } from '../../../actions/recommend-dimension-tag';
import * as actions from '../../../actions/player-search';
import * as actions_team from '../../../actions/my-topic';
import { DebounceInput } from 'react-debounce-input';
import { RankingComponent } from './ranking';
import { detectIconById } from '../../../common/enum'
import Loading from "../../../components/loading";


function Recommend(props) {
    // 選手検索用
    const [keyword, setKeyword] = useState('');
    const [selectedPlayer, setSelectedPlayer] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [individual, setIndividual] = useState(false);

    // チーム検索用
    const [team_keyword, setTeamKeyword] = useState('');
    const [selectedTeam, setSelectedTeam] = useState('');
    const [team_suggestions, setTeamSuggestions] = useState([]);
    const [team_individual, setTeamIndividual] = useState(false);

    // メジャータグ選択用
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState('');

    // ディメンションタグ選択用
    const [dimensiontags, setDimensionTags] = useState([]);
    const [selectedDimensionTag, setSelectedDimensionTag] = useState('');

    //　コンテンツ数選択用
    const [contentValues] = useState(() => {
        const arr = [];
        for (let i = 6; i <= 18; i++) {
            arr.push({ value: i, label: `${i}` });
        }
        return arr
    });
    const [selectedContentValue, setSelectedContentValue] = useState('')

    // レコメンド結果用
    const [rankingData, setRankingData] = useState([]);

    // ローディング状態を管理
    const [loading, setLoading] = useState(null);

    const dispatch = useDispatch();

    async function onGetContents() {
        setLoading(true); // ローディング開始
        try {
            const responses = await dispatch(getRecommends(selectedTag, selectedDimensionTag, selectedPlayer?.id, selectedTeam?.id, selectedContentValue, null));
            setRankingData(responses);
        } catch (e) {
            console.error('Failed to fetch data:', e);
        } finally {
            setLoading(false); // ローディング終了
        }
    };

    function onSelectedTag(value) {
        setSelectedTag(value);
    };

    function onSelectedDimensionTag(value) {
        setSelectedDimensionTag(value);
    };

    function onSelectedContentValue(value) {
        setSelectedContentValue(value);
    };

    const fetchSuggestions = async (query) => {
        if (!query) {
            setSuggestions([]);
            return;
        }
        try {
            const response = await dispatch(actions.getPlayers(query));

            setSuggestions(response);
        } catch (error) {
            console.error('Failed to fetch suggestions:', error);
        }
    };

    const fetchTags = async () => {
        try {
            if (tags.length > 0) return;
            const response = await dispatch(getTags());
            const options = [];
            response.map((category, index) => {
                options.push({
                    title: category.title,
                    value: category.id_list,  // カテゴリーの値として title を使用
                    children: category.children.map(tag => ({
                        title: tag.tag_name,
                        value: tag.tag_id,  // タグのIDを値として使用
                    }))
                });
            });
            setTags(options);
        } catch (error) {
            console.error('Failed to fetch tags:', error);
        }
    };
    fetchTags();

    const fetchDimensionTags = async () => {
        try {
            if (dimensiontags.length > 0) return;
            const response = await dispatch(getDimensionTags());
            const options = [];
            response.map((category, index) => {
                options.push({
                    title: category.title,
                    value: category.id_list,  // カテゴリーの値として title を使用
                    children: category.children.map(tag => ({
                        title: tag.tag_name,
                        value: tag.tag_id,  // タグのIDを値として使用
                    }))
                });
            });
            setDimensionTags(options);
            console.log(options)
        } catch (error) {
            console.error('Failed to fetch dimensiontags:', error);
        }
    };
    fetchDimensionTags();


    const fetchTeamSuggestions = async (query) => {
        if (!query) {
            setTeamSuggestions([]);
            return;
        }
        try {
            const response = await dispatch(actions_team.getTeams(query));
            setTeamSuggestions(response);
        }
        catch (error) {
            console.error('Failed to fetch team suggestions:', error);
        }
    };

    useEffect(() => {
        const timerId = setTimeout(() => {
            fetchSuggestions(keyword);
        }, 300);

        return () => clearTimeout(timerId);
    }, [keyword]);

    useEffect(() => {
        const timerId = setTimeout(() => {
            fetchTeamSuggestions(team_keyword);
        }, 300);

        return () => clearTimeout(timerId);
    }, [team_keyword]);

    const handleSuggestionClick = (player) => {
        setSelectedPlayer(player);
        setKeyword(player.player_name);
        setIndividual(false);
    };

    const handleTeamSuggestionClick = (team) => {
        setSelectedTeam(team);
        setTeamKeyword(team.team_name);
        setTeamIndividual(false);
    };
    // リセットボタン用の関数
    const onReset = () => {
        setKeyword('');
        setSelectedPlayer('');
        setSuggestions([]);
        setIndividual(false);

        setTeamKeyword('');
        setSelectedTeam('');
        setTeamSuggestions([]);
        setTeamIndividual(false);

        setSelectedTag('');
        setSelectedDimensionTag('');
        setSelectedContentValue('');
    };

    return (
        <>
            <div className="wrap-my-recommend">
                <div className="title-my-recommend">
                    <h1>レコメンド
                        <span>
                            <i className="fa fa-question-circle"></i>
                            <div className='tooltips-my-recommend'><p>アナリストの思考回路を反映させたアルゴリズムで、選手やチームのおすすめデータを表示します</p></div>
                        </span>
                    </h1>
                    <div className="title-right">
                        <div className="search">
                            <DebounceInput
                                style={{ outline: 'none' }}
                                placeholder="選手名検索"
                                minLength={0}
                                debounceTimeout={300}
                                value={selectedPlayer?.player_name || ''}
                                onChange={e => { setKeyword(e.target.value); setIndividual(true); }}
                            />
                            <img alt="search" src="/img/ic_search_svg.svg" />
                            {individual && suggestions.length > 0 && (
                                <ul className="suggestions-list">
                                    {suggestions.map((suggestion, index) => (
                                        <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                            <div>
                                                <img style={{ width: 20, marginRight: 10 }}
                                                    src={detectIconById(suggestion.team.id)} alt="team-name" />
                                                {suggestion.player_name}
                                                <span style={{
                                                    color: '#74818A',
                                                    fontSize: 13,
                                                    marginLeft: 10
                                                }}>{suggestion.uniform_number}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="search">
                            <DebounceInput
                                style={{ outline: 'none' }}
                                placeholder="チーム名検索"
                                minLength={0}
                                debounceTimeout={300}
                                value={selectedTeam?.team_name || ''}
                                onChange={e => { setTeamKeyword(e.target.value); setTeamIndividual(true); }}
                            />
                            <img alt="search" src="/img/ic_search_svg.svg" />
                            {team_individual && team_suggestions.length > 0 && (
                                <ul className="suggestions-list">
                                    {team_suggestions.map((suggestion, index) => (
                                        <li key={index} onClick={() => handleTeamSuggestionClick(suggestion)}>
                                            <div>
                                                <img style={{ width: 20, marginRight: 10 }}
                                                    src={detectIconById(suggestion.id)} alt="team-name" />
                                                {suggestion.team_name}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="select-button-group">
                            <TreeSelect
                                treeCheckable
                                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                                style={{ width: 180 }}
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                treeData={tags}
                                placeholder="指標タグ"
                                onChange={onSelectedTag}
                                value={selectedTag || undefined}
                                treeDefaultExpandAll
                                allowClear
                                showSearch  // 検索機能を追加
                                filterTreeNode={(input, node) =>
                                    node.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            />
                            
                            <TreeSelect
                                treeCheckable
                                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                                style={{ width: 180 }}
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                treeData={dimensiontags}
                                placeholder="特徴タグ"
                                onChange={onSelectedDimensionTag}
                                value={selectedDimensionTag || undefined}
                                treeDefaultExpandAll
                                allowClear
                                showSearch  // 検索機能を追加
                                filterTreeNode={(input, node) =>
                                    node.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            />

                            <Select
                                style={{ width: 120 }}
                                onChange={onSelectedContentValue}
                                value={selectedContentValue || undefined}
                                options={contentValues}
                                placeholder="表示件数"
                            />
                            <button className='btn-reset-recommend' onClick={onReset}>
                                条件リセット
                            </button>
                            <button className='btn-add-recommend' onClick={onGetContents}>
                                データ取得
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrap-my-recommend">
                    <div className="content-my-recommend">
                        <div className='content-my-recommend-container'>
                            {loading ? (
                                <Loading show={loading} />
                            ) : rankingData.length > 0 ? (
                                console.log(selectedPlayer?.id),
                                console.log(selectedTeam?.id),
                                rankingData.map((data, index) => (
                                    <RankingComponent key={index} ranking={data} player_id={selectedPlayer?.id} team_id={selectedTeam?.id} />
                                ))
                            ) : (
                                <div className='no-data-message'>
                                    <i className='icon-no-data'></i>
                                    <p>お探しのデータは存在しません。</p>
                                </div>
                            )

                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Recommend;